const offensiveFoulFirstDefenderActions = [
  {
    actions: [
      { action: "sendEvent", value: "edit", type: "main" },
      { action: "copyEvent", value: "offensive-foul-first-defender", type: "to" },
      {
        action: "nextState",
        value: "offensive-foul-second-defender",
        type: "primary",
      },
    ],
    conditions: [],
  },
];

export const OffensiveFoulFirstDefender = {
  name: "offensive-foul-first-defender",
  component: "MainPanel",
  layout: "main-panel large align-center",
  mode: "visible",
  text: "offensiveFoul.defender.select",
  showOn: [{ state: "primary", value: "offensive-foul-first-defender", operator: "is" }],
  allowFlag: true,
  allowCancel: true,
  allowCancelEvent: "main",
  allowCancelPlay: true,
  cancelActions: [
    {
      actions: [{ action: "clearAllEvents" }],
      conditions: [],
    },
  ],
  showDetails: { events: ["main"] },
  allowBack: {
    state: "primary",
    value: "technical-fault-player",
    event: "offensive-foul-technical-fault",
  },
  children: [
    {
      name: "prepare-offensive-foul-first-defender",
      component: "PreAction",
      layout: "pre-action",
      mode: "enable",
      showOn: [true],
      startEvent: false,
      startPlay: false,
      actionGroups: [
        {
          actions: [
            { action: "copyEvent", value: "offensive-foul-technical-fault", type: "from" },
            { action: "modifyEvent", value: "swapEntities", type: "main" },
            { action: "newEvent", value: null, type: "main" },
            {
              action: "clearData",
              value: ["personId", "flagged", "scores", "success"],
              type: "main",
            },
            { action: "saveData", value: "foul", type: "eventType" },
            { action: "saveData", value: "drawn", type: "subType" },
            {
              action: "saveData",
              value: [{ option: "offensive", value: true }],
              type: "options",
            },
            { action: "sendEvent", value: "new", type: "main" },
            { action: "copyEvent", value: "offensive-foul-first-defender", type: "to" },
          ],
          conditions: [
            {
              item: "eventDefined",
              value: "offensive-foul-first-defender",
              operator: "not",
            },
          ],
        },
        {
          actions: [{ action: "copyEvent", value: "offensive-foul-first-defender", type: "from" }],
          conditions: [
            {
              item: "eventDefined",
              value: "offensive-foul-first-defender",
              operator: "is",
            },
          ],
        },
      ],
    },
    {
      name: "offensive-foul-first-defender-select",
      component: "PlayerSelect",
      layout: "player-select",
      mode: "visible",
      startEvent: false,
      startPlay: false,
      showOn: [true],
      options: {
        currentEntity: true,
        showBench: false,
        showCoach: false,
      },
      actionGroups: [
        {
          actions: [{ action: "clearData", value: ["flagged"], type: "main" }],
          conditions: [],
        },
        ...offensiveFoulFirstDefenderActions,
      ],
    },
    {
      name: "confirm-later-offensive-foul-first-defender",
      component: "TypeButton",
      layout: "match-button",
      mode: "enable",
      text: "confirmLater",
      showOn: [true],
      startEvent: false,
      startPlay: false,
      actionGroups: [
        {
          actions: [
            { action: "saveData", type: "flagged", value: true },
            { action: "clearData", value: ["personId"], type: "main" },
          ],
          conditions: [],
        },
        ...offensiveFoulFirstDefenderActions,
      ],
    },
  ],
};
